export default __webpack_public_path__ + "static/media/logo1.b3f2025b.png";